import React from 'react';
import { useFormContext, Controller, FieldError } from 'react-hook-form';
import {
    MentionsInput,
    Mention,
    MentionsInputProps,
    MentionProps,
} from 'react-mentions';
import { colors } from 'common/constants';
import { Box, Typography } from '@mui/material';

type Props = MentionsInputProps &
    MentionProps & {
        name: string;
        helperText?: string;
        customMentionStyle?: (error: FieldError | undefined) => object;
        maxLength?: number;
    };

export default function BaseTextField({
    name,
    customMentionStyle,
    maxLength = 100000,
    singleLine = false,
    ...other
}: Props) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Box sx={{ flex: 1, width: 0 }}>
                    <MentionsInput
                        value={field.value}
                        onChange={(evt) => {
                            const input = evt.target.value;
                            const trimmed = input.slice(0, maxLength);
                            field.onChange(trimmed);
                        }}
                        singleLine={singleLine}
                        style={customMentionStyle && customMentionStyle(error)}
                        {...other}
                    >
                        <Mention
                            trigger={other.trigger}
                            markup={other.markup}
                            displayTransform={other.displayTransform}
                            data={other.data}
                            onAdd={other.onAdd}
                        />
                    </MentionsInput>

                    {error && (
                        <Typography
                            sx={{
                                fontSize: '14px',
                                marginTop: '4px',
                                color: `${colors.textError} !important`,
                                fontWeight: '400',
                            }}
                        >
                            {error.message}
                        </Typography>
                    )}
                </Box>
            )}
        />
    );
}
